export function saveUser(user) {
	if (window.localStorage) {
		window.localStorage.setItem("user", JSON.stringify(user));
	}
}

// Returns the user or undefined
export function getUser() {
	if (window.localStorage) {
		const uString = window.localStorage.getItem("user");
		if (!uString) return undefined;
		try {
			return JSON.parse(uString);
		} catch (error) {
			return undefined;
		}
	}
}

export function saveOrganisation(organisation) {
	if (window.localStorage) {
		window.localStorage.setItem(
			"organisation",
			JSON.stringify(organisation)
		);
	}
}

// Returns the Organisation or undefined
export function getOrganisation() {
	if (window.localStorage) {
		const uString = window.localStorage.getItem("organisation");
		if (!uString) return undefined;
		try {
			return JSON.parse(uString);
		} catch (error) {
			return undefined;
		}
	}
}

export function clearUser() {
	if (window.localStorage) {
		window.localStorage.removeItem("user");
	}
}

export function saveToken(token) {
	if (window.localStorage) {
		window.localStorage.setItem("token", token);
	}
}

export function setImpersonation(state) {
	if (window.localStorage) {
		window.localStorage.setItem("impersonation", state);
	}
}

export function clearImpersonation() {
	if (window.localStorage) {
		window.localStorage.removeItem("impersonation");
	}
}

// returns token or undefined
export function getToken() {
	if (window.localStorage) {
		return window.localStorage.getItem("token");
	}
}

export function clearToken() {
	if (window.localStorage) {
		window.localStorage.removeItem("token");
	}
}

export function intercomData(user) {
	let name = user.firstname;

	if (user.lastname) {
		name = `${name} ${user.lastname}`;
	}

	return {
		user_id: user.id,
		user_hash: user.intercom,
		name,
		email: user.email
	};
}
